// Formularios públicos (contacto, financiamiento, compra directa, consignación, buscamos por ti, modales de datos/éxito) y correos de leads — Português (Brasil). Mismas claves que es/formsUi.ts.
export const formsUiPt = {
  errors: {
    noClient:
      '❌ Erro: não foi possível identificar a concessionária. Por favor, recarregue a página.',
    generic:
      'Ocorreu um erro ao enviar sua solicitação. Por favor, tente novamente.',
    emailNotSent:
      'Não foi possível enviar a notificação por e-mail, mas sua solicitação foi registrada. Entraremos em contato em breve.',
    duplicate:
      'Já existe uma solicitação com esses dados. Por favor, confira as informações.',
    invalidEmail:
      'Erro com o e-mail. Por favor, confira se o e-mail é válido.',
    customer:
      'Erro ao registrar o cliente. Por favor, confira os dados pessoais.',
    lead: 'Erro ao registrar a solicitação. Por favor, confira os dados do veículo.',
    technicalDetails: 'Detalhes técnicos',
    requiredFields:
      '❌ Por favor, preencha todos os campos obrigatórios (Nome, Sobrenome, E-mail, Telefone).',
    brandAndModel: '❌ Por favor, selecione a marca e o modelo do veículo.',
    requiredField: '❌ Por favor, preencha o campo obrigatório: ',
  },
  success: {
    title: 'Solicitação enviada com sucesso!',
    message:
      'Recebemos sua solicitação. Entraremos em contato com você o quanto antes.',
    button: 'OK',
    consignment:
      'Recebemos sua solicitação de consignação. Entraremos em contato com você o quanto antes para avaliar seu veículo.',
    buyDirect:
      'Recebemos sua solicitação de venda. Um consultor entrará em contato para oferecer uma proposta pelo seu veículo.',
    financing:
      'Recebemos sua solicitação de financiamento. Um consultor entrará em contato para apresentar as opções disponíveis.',
    contact:
      'Recebemos sua mensagem. Entraremos em contato com você o quanto antes.',
    search:
      'Recebemos sua solicitação de busca. Entraremos em contato quando encontrarmos veículos que atendam aos seus critérios.',
  },
  buyDirect: {
    successAppraisal:
      'Recebemos os dados do seu veículo. Em alguns minutos você receberá por e-mail um preço estimado de compra, e um consultor entrará em contato para agendar a avaliação presencial.',
    platePlaceholderBr: 'Ex: ABC1D23',
    plateInvalidBr: 'Confira a placa: formato ABC1D23 (Mercosul) ou ABC1234.',
  },
  weSearch: {
    cpfLabelBr: 'CPF',
  },
  contact: {
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    phone: 'Telefone',
    reason: 'Motivo do contato',
    reasons: {
      buy: 'Compra de veículo',
      sell: 'Venda de veículo',
      general: 'Dúvida geral',
      other: 'Outro',
    },
    message: 'Mensagem',
    submit: 'Enviar mensagem',
    infoTitle: 'Informações de contato',
    location: 'Endereço',
    hours: 'Horário de funcionamento',
    directContact: 'Contato direto',
    emailsLabel: 'E-mails',
    emailLabel: 'E-mail',
    phoneLabel: 'Telefone',
  },
  contactPage: {
    title: 'Contato',
    subtitle:
      'Estamos aqui para ajudar. Envie uma mensagem e responderemos o quanto antes.',
  },
  customerModal: {
    title: 'Salve seus veículos favoritos!',
    description:
      'Avisaremos você quando encontrarmos veículos parecidos com bom preço.',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    phone: 'Telefone',
    cancel: 'Cancelar',
    saving: 'Salvando...',
    save: 'Salvar',
  },
};
